/** Representa um anexo de intercorrência */
export interface IAttachment {
  id: string;
  file_name: string;
  storage_key: string;
  file_url: string;
  file_size: number;
  content_type: string;
  attachment_order: number;
  created_at?: string;
}

/** Resposta do endpoint de presigned URL (camelCase — backend sem @JsonNaming) */
export interface IPresignedUrlResponse {
  fileName: string;
  uploadUrl: string;
  objectKey: string;
}

/** Estado local de upload de um arquivo */
export interface IUploadingFile {
  file: File;
  fileName: string;
  fileSize: number;
  contentType: string;
  progress: number;          // 0-100
  status: 'pending' | 'uploading' | 'registering' | 'done' | 'error';
  previewUrl: string | null; // Data URL para imagens
  errorMessage?: string;
  attachment?: IAttachment;  // Preenchido após registro com sucesso
}

/** Tipos de arquivo aceitos */
export const ACCEPTED_FILE_TYPES: Record<string, string[]> = {
  'Imagens': ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/heic', 'image/heif'],
  'PDF': ['application/pdf'],
  'Documentos': [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ],
  'Apresentações': [
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  ],
  'Vídeos': ['video/mp4', 'video/webm', 'video/quicktime', 'video/x-msvideo']
};

/** Lista plana de MIME types aceitos */
export const ACCEPTED_MIME_TYPES: string[] = Object.values(ACCEPTED_FILE_TYPES).flat();

/** Tamanho máximo de arquivo (100 MB) */
export const MAX_FILE_SIZE = 100 * 1024 * 1024;

/** Extensões aceitas para o input de arquivo */
export const ACCEPTED_EXTENSIONS = '.jpg,.jpeg,.png,.gif,.webp,.heic,.heif,.pdf,.doc,.docx,.ppt,.pptx,.mp4,.webm,.mov,.avi';
